
import DocumentPrevious from "../../../assets/duotone/DocumentPrevious.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DocumentPreviousIcon({ className, dataTestid = "DocumentPreviousIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DocumentPrevious data-testid={dataTestid} className={classes} {...rest} />
  );
}
